import { isBillingCountryUSA } from '../helper/utilityMethods';

export const mapVendorFormData = (formData, isDraft = 'N') => {
  const [fedTax, tin] = isBillingCountryUSA(
    formData.billingCountry?.CountryName ?? ''
  )
    ? [formData.tin, '']
    : ['', formData.tin];

  return {
    name: formData.supplierRegisteredName,
    region: formData.region,
    currency: formData.billingCurrency,
    country: formData.billingCountry,
    otherCountryName:
      formData.billingCountry.CountryName?.toLowerCase() === 'other'
        ? formData.otherCountry
        : '',
    regisLocalName: formData.supplierRegisteredLocalName,
    regisAddress: formData.supplierRegisteredAddress_Line1,
    regisAddress2: formData.supplierRegisteredAddress_Line2,
    regisLocalAddress: formData.supplierRegisteredLocalAddress_Line1,
    regisLocalAddress2: formData.supplierRegisteredLocalAddress_Line2,
    city: formData.city,
    state: formData.state,
    postalCode: formData.postalCode,
    otherSupplierCountry: formData.country,
    otherSupplierCountryName: formData.otherCountryName,
    supplierEmailAddress: formData.supplierEmailAddress,
    payeeName: formData.payeeName,
    payeeLocalName: formData.payeeLocalName,
    payeeAddress: formData.payeeAddress_Line1,
    payeeAddress2: formData.payeeAddress_Line2,
    payeeLocalAddress: formData.payeeLocalAddress_Line1,
    payeeLocalAddress2: formData.payeeLocalAddress_Line2,
    payeeCity: formData.payeeCity,
    payeeState: formData.payeeState,
    payeePostalCode: formData.payeePostalCode,
    payeeCountry: formData.payeeCountry,
    otherPayeeCountryName: formData.otherPayeeCountryName,
    isFinDecisonMkr: formData.isKeyFinancialDecisionMaker === 'Yes' ? 'Y' : 'N',
    supContactName: formData.supplierContactPerson,
    phoneNo: formData.supplierPhoneNumber,
    supplierEmailAddress: formData.supplierEmailAddress,
    drafterEmailId: isDraft === 'Y' ? formData.drafterEmailId : '',
    fax: formData.supplierFaxNumber,
    abnNo: formData.abn,
    busRegisCertNo: formData.businessRegCertNo,
    isMsme: formData.isMsme === 'Yes' ? 'Y' : 'N',
    panNo: formData.panNo,
    srvcTaxNo: formData.serviceTaxNo,
    regisState: formData.registeredState,
    regisStateNo: formData.registeredStateNo,
    fedTaxNo: fedTax,
    taxIdNo: tin,
    uenNo: formData.uen,
    gstNo: formData.gstNo,
    sirenNumber: formData.sirenNumber,
    siretNumber: formData.siretNumber,
    isAuditFirm: formData.isAuditFirm === 'Yes' ? 'Y' : 'N',
    paytMethod: formData.paymentMethod,
    otherPymtMthd: formData.otherPaymentMethod,
    remitEmailId: formData.remittanceEmailAddress,
    paytTerms: formData.paymentTerms,
    requesterName: formData.amexContactName,
    requesterPhoneNo: formData.amexContactNumber,
    requestorEmailId: formData.amexContactEmail,
    requesterBusUnit: formData.amexContactBusinessUnit,
    seNo: formData.serviceEstablishment,
    nifCode: formData.nif,
    bankName: formData.bankName,
    switftCode: formData.bic,
    branchName: formData.branchName,
    branchCode: formData.branchCode,
    accNo: formData.accountNumber,
    bankCode: formData.bankCode,
    accType: formData.accountType,
    abaRouteNo: formData.aba,
    interBankName: formData.intermediateBankName,
    interBankSwiftCode: formData.intermediateBankBic,
    interBankBranchName: formData.intermediateBankBranchName,
    interimBranchCode: formData.intermediateBankBranchCode,
    interBankAccNumber: formData.intermediateBankAccountNumber,
    interBankAbaRouteNo: formData.intermediateABA,
    japaBankName: formData.japanBankName,
    japaBranchName: formData.japanBranchName,
    giroBankNo: formData.bankGiroNumber,
    isDraft: isDraft,
    acknowledgementCheck: formData.acknowledgementCheck ?? false,
  };
};

// maps the draft data to formData
export const mapDraftData = (supplier) => {
  const [tin] = isBillingCountryUSA(supplier.country?.CountryName ?? '')
    ? [supplier.fedTaxNo ?? '']
    : [supplier.taxIdNo ?? ''];

  return {
    supplierRegisteredName: supplier.name ?? '',
    region: supplier.region ?? '',
    billingCurrency: supplier.currency ?? {
      CurrencyName: '',
      CurrencyCode: '',
    },
    billingCountry: supplier.country ?? { CountryName: '', CountryCode: '' },
    otherCountry: supplier.otherCountryName,
    otherCountryName: supplier.otherSupplierCountryName ?? '',
    supplierRegisteredLocalName: supplier.regisLocalName ?? '',
    supplierRegisteredAddress_Line1: supplier.regisAddress ?? '',
    supplierRegisteredAddress_Line2: supplier.regisAddress2 ?? '',
    supplierRegisteredLocalAddress_Line1: supplier.regisLocalAddress ?? '',
    supplierRegisteredLocalAddress_Line2: supplier.regisLocalAddress2 ?? '',
    city: supplier.city ?? '',
    state: supplier.state,
    postalCode: supplier.postalCode ?? '',
    country: supplier.otherSupplierCountry ?? {
      CountryName: '',
      CountryCode: '',
    },
    supplierEmailAddress: supplier.supplierEmailAddress ?? '',
    payeeName: supplier.payeeName ?? '',
    payeeLocalName: supplier.payeeLocalName ?? '',
    payeeAddress_Line1: supplier.payeeAddress ?? '',
    payeeAddress_Line2: supplier.payeeAddress2 ?? '',
    payeeLocalAddress_Line1: supplier.payeeLocalAddress ?? '',
    payeeLocalAddress_Line2: supplier.payeeLocalAddress2 ?? '',
    payeeCity: supplier.payeeCity ?? '',
    payeeState: supplier.payeeState,
    payeePostalCode: supplier.payeePostalCode ?? '',
    payeeCountry: supplier.payeeCountry ?? { CountryName: '', CountryCode: '' },
    otherPayeeCountryName: supplier.otherPayeeCountryName ?? '',
    isKeyFinancialDecisionMaker:
      supplier.isFinDecisonMkr === 'Y' ? 'Yes' : 'No',
    supplierContactPerson: supplier.supContactName ?? '',
    supplierPhoneNumber: supplier.phoneNo ?? '',
    supplierEmailAddress: supplier.supplierEmailAddress ?? '',
    supplierFaxNumber: supplier.fax ?? '',
    gstNo: supplier.gstNo ?? '',
    sirenNumber: supplier.sirenNumber ?? '',
    siretNumber: supplier.siretNumber ?? '',
    abn: supplier.abnNo,
    businessRegCertNo: supplier.busRegisCertNo,
    isMsme: supplier.isMsme === 'Y' ? 'Yes' : 'No',
    panNo: supplier.panNo,
    serviceTaxNo: supplier.srvcTaxNo,
    registeredState: supplier.regisState,
    registeredStateNo: supplier.regisStateNo,
    tin: tin,
    uen: supplier.uenNo,
    isAuditFirm: supplier.isAuditFirm === 'Y' ? 'Yes' : 'No' ?? '',
    paymentMethod: supplier.paytMethod ?? '',
    otherPymtMthd: supplier.otherPymtMthd ?? '',
    remittanceEmailAddress: supplier.remitEmailId ?? '',
    paymentTerms: supplier.paytTerms ?? '',
    amexContactName: supplier.requesterName ?? '',
    amexContactNumber: supplier.requesterPhoneNo ?? '',
    amexContactEmail: supplier.requestorEmailId ?? '',
    amexContactBusinessUnit: supplier.requesterBusUnit ?? '',
    serviceEstablishment: supplier.seNo ?? '',
    nif: supplier.nifCode,
    bankName: supplier.bankName ?? '',
    bic: supplier.switftCode ?? '',
    branchName: supplier.branchName ?? '',
    branchCode: supplier.branchCode ?? '',
    accountNumber: supplier.accNo ?? '',
    bankCode: supplier.bankCode ?? '',
    accountType: supplier.accType ?? '',
    aba: supplier.abaRouteNo ?? '',
    intermediateBankName: supplier.interBankName ?? '',
    intermediateBankBic: supplier.interBankSwiftCode ?? '',
    intermediateBankBranchName: supplier.interBankBranchName ?? '',
    intermediateBankBranchCode: supplier.interimBranchCode ?? '',
    intermediateBankAccountNumber: supplier.interBankAccNumber ?? '',
    intermediateABA: supplier.interBankAbaRouteNo ?? '',
    japanBankName: supplier.japaBankName,
    japanBranchName: supplier.japaBranchName,
    bankGiroNumber: supplier.giroBankNo,
    approverComment: supplier.approverComment,
    acknowledgementCheck: supplier.acknowledgementCheck ?? false,
  };
};
